// IE 2026 09 28 / ODOO-342342 (рабочая область «Инструкции», шаг 3 плана — фронт): читалки документации листают на месте, с историей. — IE 2026 11 02 / ODOO-349799 (workspace-wording)
// Проект: ie-webscm7-2 docs/userdocs-2026-09-25/instructions_workspace_design_2026-09-27.md (§3 «Панель Документація», вариант C).
//
// Что было.
//   - Ссылка `docs:` в любом AttrMD открывала панель документации widget-docs (store.widget_open); внутри самой панели — жёстким закрытием
//     и переоткрытием от родителя (AttrMD._openDocLink). Читалка на странице (запись WIDGET-DOCS со своим doc.doc_link) на ссылку открывала
//     ОТДЕЛЬНУЮ панель; кнопки «Назад» не было.
//   - Уже открытая панель на «?» другого виджета или на ссылку не из панели лишь активировалась — со СТАРЫМ документом: findWidget_byProps
//     сравнивает id виджета и записи, а не doc_link (дефект «прежний документ»).
//   - В сыром HTML превью (плитки `<a href="docs:…">`, html_block → innerHTML) ссылку `docs:` браузер пытался открыть как адрес.
//
// Что стало (флаг fe.help.inPlaceDocs, по умолчанию ВКЛ).
//   - Читалка — виджет с widget_class widget_DOCS или записью сегмента WIDGET-DOCS: и панель «?», и читалка страницы. Ссылка внутри неё
//     листает её НА МЕСТЕ: метод бэка open_doc (executeWidgetMethod, params.doc_link = '<путь>[#якорь]' — без схемы docs:, как у
//     widget_open: бэк (widget_DOCS.open_doc → _docs_locate) схему не снимает); ответ — {command: 'updateDoc', record, title}, запись с теми
//     же полями, что у widget_DOCS.initialize (doc.md_text, doc.doc_link, doc.anchor, doc.docs_title, doc.docs_contents, doc.docs_i18n).
//     Прежний документ уходит в историю читалки (WIDGET._docsNav.back, не больше HISTORY_MAX).
//   - Кнопки читалки (AttrMD.set_commandPanel): «Back» — есть история; «Contents» — ссылка на оглавление от бэка (doc.docs_contents: у
//     страниц docs/user-guide/ кроме самого index.md, '' — кнопки нет); запись без этого поля (бэк до open_doc) — то же правило по пути.
//   - Панель уже открыта на ДРУГОМ документе — store.widget_open листает её (docsNav_panelSwap, с историей), а не активирует со старым
//     текстом; скрытая (Esc) или на бэке без open_doc — закрывается жёстко и открывается заново на нужном документе.
//   - Сырой HTML превью: делегированный клик по a[href^="docs:"] (AttrMD._onPreviewClick) — та же навигация, что у markdown-ссылок.
//
// Удачный ответ — только документ: запись с НЕПУСТЫМ текстом (doc.md_text) и без признака ошибки (docsNav_verdict). Остальное — неудача:
// ответ не применяется (проверка в _response_callback — ДО того, как store применит updateDoc: команда снимается, читалка остаётся как
// была), в историю ничего не пишется, тихо идёт прежний путь (панель / переоткрытие), своих тостов фронт не показывает.
//   - Бэк без open_doc (прод и dev до выката бэка): views.executeWidgetMethod на незнакомый метод пишет TERMINAL с frontend=False и отвечает
//     пустым ответом без уведомления. «Записи нет, ошибки нет» — фронт запоминает «этот бэк не умеет» на пару база · версия бэка: дальше
//     запрос не шлётся, кнопки Back / Contents не показываются.
//   - Ошибка (уведомление error / critical, HTTP-ошибка, запись без текста — «wrong link», текст-заглушка «Documentation file `…` not
//     found.») — прежний путь, но без запоминания: механизм не выключается.
//
// Выключатель: window.feSettings.set('fe.help.inPlaceDocs', false) или ?fe.help.inPlaceDocs=false в URL — всё как до правки.
// Консоль: window.helpDocs.get() / .set('inPlaceDocs', false) / .reset() / .stats() / .clear() / .help().
// Модуль без импортов (store и DOM приходят параметрами) — его логику проверяет tests/unit/docsNav.test.mjs: node --test 'tests/unit/*.test.mjs'

export const FLAG = 'fe.help.inPlaceDocs'
// IE 2026 09 28 / ODOO-342342 (Igor: «добавь в элемент-инструкции поиск как в форме-меню»; «меню — прижато вправо и использовать форму меню
// как на скрин2»): меню читалки — форма MenuPanel справа в шапке (группы Contents · All guides · Command panel, поиск, «Found in text»),
// логика — utils/docsSearch.js. Выключатель fe.help.docsSearch (по умолчанию ВКЛ): false — прежнее ≡ (wj-menu) и «Contents» ведёт на оглавление
export const DOCS_SEARCH_FLAG = 'fe.help.docsSearch'
// IE 2026 09 28 / ODOO-342342 (дефект «шапка читалки при первом открытии»): заголовок окна читалки — H1 документа (doc.docs_title) уже при открытии.
// Замер dev02 / Demo (tools/uc_reader_title_probe.mjs): строка страницы «User guide» открывает читалку с title = подписью строки (store.workspace_show_widgets
// → parentAction.title), бэк возвращает её же эхом в WIDGET.title, а H1 кладёт только в record.doc.docs_title («Working with the WebSCM interface»);
// после листания (open_doc → updateDoc title) шапка уже H1. То же у панели «?» отчёта (замечание ie-demo7, verify-align §16.5): фронт шлёт title
// «Documentation» (подпись кнопки), бэк возвращает его эхом. Теперь у панели «?» и у читалок WIDGET-DOCS заголовок — H1 текущего документа, при листании
// обновляется; подпись строки / «Documentation» — только запасной вариант, если H1 нет. Выключатель — свой: helpDocs.set('readerTitleH1', false) — как до правки
export const FLAG_TITLE = 'fe.help.readerTitleH1'
// IE 2026 09 28 / ODOO-342342: методы бэка читалки — только объявленные им в ответе читалки: WIDGET.docs_capabilities (бэк с веткой
// ie-webscm7-2/docs-index-unsupported-342342 объявляет ['docs_index', 'open_doc']). Бэк без признака (прод be-dm ad498982d — нет ни docs_index,
// ни open_doc; be-fado 7e2bf6886 — нет docs_index) не спрашивается: каждый вызов незнакомого метода — «!!ERROR (method=…)» в его логе. Без
// open_doc ссылки читалки идут прежним путём (панель документации widget-docs, как до листания на месте — AttrMD._openDocLink_legacy), без
// docs_index меню читалки — без «Found in text». Выключатель у каждого метода свой (по умолчанию ВКЛ): false — спрашивать и без признака,
// как до правки (ответ «метода нет» запоминается: open_doc — по базе · версии бэка, docs_index — по базе до перезагрузки страницы)
export const DOCS_INDEX_CAP_FLAG = 'fe.help.docsIndexCapability'
export const OPEN_DOC_CAP_FLAG = 'fe.help.openDocCapability'
const CAP_FLAGS = { docs_index: DOCS_INDEX_CAP_FLAG, open_doc: OPEN_DOC_CAP_FLAG }
const FLAGS = { inPlaceDocs: FLAG, docsSearch: DOCS_SEARCH_FLAG, readerTitleH1: FLAG_TITLE, docsIndexCapability: DOCS_INDEX_CAP_FLAG, openDocCapability: OPEN_DOC_CAP_FLAG }   // IE 2026 09 28 / ODOO-342342: + docsSearch (меню читалки с поиском), + readerTitleH1 (заголовок читалки — H1); + docsIndexCapability, openDocCapability (IE 2026 09 28 / ODOO-342342: docs_index / open_doc только по признаку бэка)
export const GUIDE_DIR = 'user-guide/'                       // каталог руководства пользователя внутри docs/
export const CONTENTS_LINK = 'docs/user-guide/index.md'     // «Contents» — оглавление всех инструкций
export const HISTORY_MAX = 50
// команды ответа, которые store.executeStoreMethod применяет к виджету сам (запись, заголовок, content_Changed)
const APPLIED_BY_STORE = new Set(['updateDoc', 'updateWIDGET', 'updateWidget'])

const stats = {
    inPlace: 0, inPlaceMs: 0,   // пролистано на месте (open_doc ответил записью) и сумма времени ответов, мс
    link: 0,                    // из них — ссылкой внутри читалки
    back: 0, contents: 0,       // — кнопками Back / Contents
    panelReused: 0,             // — уже открытая панель на «?» / ссылку снаружи (вместо активации со старым документом)
    panelReopened: 0,           // уже открытая панель закрыта и открыта заново на нужном документе (скрыта / бэк без open_doc)
    tileClicks: 0,              // клики по a[href^="docs:"] в сыром HTML превью
    fallback: 0, fallbackMs: 0, // open_doc не дал записи — прежний путь; сколько стоил лишний запрос, мс
    errors: 0,                  // из них — ответ с ошибкой бэка (без запоминания «не умеет»)
    skipped: 0,                 // запрос не отправлялся: этот бэк уже ответил, что open_doc нет
    noCapability: 0,            // IE 2026 09 28 / ODOO-342342: запрос не отправлялся — бэк не объявил open_doc (WIDGET.docs_capabilities)
    jump: 0, jumpBack: 0,       // IE 2026 09 28 / ODOO-342342: переход к разделу того же документа (меню читалки) и возврат из него — без запроса бэка
    menu: 0,                    // IE 2026 09 28 / ODOO-342342: пролистано на месте выбором пункта меню читалки (другой документ)
    titleH1: 0,                 // IE 2026 09 28 / ODOO-342342: заголовок читалки заменён на H1 документа (ответ открытия / обновления вёл подпись строки страницы)
}
const support = {}   // `${dbid}|${version_backend}` → true | false (нет ключа — ещё не спрашивали)

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now())
const round = (x) => Math.round(x * 10) / 10

// Текст-заглушка docs_read бэка для отсутствующего файла (widgets.docs_read: «Documentation file `<имя>` not found.»)
const DOCS_NOT_FOUND_RE = /^Documentation file `[^`]*` not found\.?$/

// Вердикт ответа open_doc: 'ok' — документ (запись с непустым текстом, без признака ошибки); 'unsupported' — пустой ответ без ошибки
// (старый бэк, метода нет); 'error' — всё остальное (нет ответа, уведомление error / critical, запись без текста, заглушка «not found»)
export function docsNav_verdict(answer) {
    if (!answer || typeof answer !== 'object') return 'error'
    if (answer.isAuthenticated === false) return 'error'   // IE 2026 09 28 / ODOO-342342 (ревью п.6): сессия истекла — не «метода нет»
    const status = answer.notification?.status
    if (status === 'error' || status === 'critical' || answer.error) return 'error'
    const rec = answer.record || answer.WIDGET?.record
    if (!rec) return 'unsupported'
    const text = rec.doc?.md_text
    if (typeof text !== 'string' || !text.trim() || DOCS_NOT_FOUND_RE.test(text.trim())) return 'error'
    return 'ok'
}

export function docsNav_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG, true) === false) } catch (e) { return true }
}
// IE 2026 09 28 / ODOO-342342: меню читалки (MenuPanel с поиском по инструкциям) включено — fe.help.docsSearch, по умолчанию да
export function docsSearch_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(DOCS_SEARCH_FLAG, true) === false) } catch (e) { return true }
}

// Читалка документации: панель «?» (widget-docs) или запись сегмента WIDGET-DOCS, поставленная на страницу
export function docsNav_isDocs(WIDGET) {
    return !!WIDGET && (WIDGET.widget_class === 'widget_DOCS' || WIDGET.record?.segment === 'WIDGET-DOCS' || WIDGET.widget === 'widget-docs')
}

// IE 2026 09 28 / ODOO-342342 (дефект «шапка читалки при первом открытии»): заголовок читалки — H1 показанного документа (doc.docs_title от
// widget_DOCS._docs_load, язык интерфейса), а не подпись строки страницы, которую бэк возвращает эхом в WIDGET.title. Зовётся после ответа
// widget_open и после updateWIDGET / updateDoc (store). true — заголовок заменён. Флаг выключен, не читалка, H1 нет (бэк без docs_title) или
// заголовок уже он — ничего не делает
export function docsNav_titleOn(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG_TITLE, true) === false) } catch (e) { return true }
}
export function docsNav_applyTitle(store, WIDGET) {
    if (!WIDGET || !docsNav_titleOn(store) || !docsNav_isDocs(WIDGET)) return false
    const h1 = String(WIDGET.record?.doc?.docs_title ?? '').trim()
    if (!h1 || WIDGET.title === h1) return false
    WIDGET.title = h1
    stats.titleH1++
    return true
}

// Ссылка без схемы `docs:` — в том виде, в каком её хранит doc.doc_link (путь[#якорь]); percent-декодирует вызывающий (AttrMD._openDocLink)
export function docsNav_norm(link) {
    let s = String(link == null ? '' : link).trim()
    if (s.startsWith('docs:')) s = s.slice(5).trim()
    return s.replace(/^\.\//, '')
}
export function docsNav_same(a, b) {
    const x = docsNav_norm(a)
    return !!x && x === docsNav_norm(b)
}
export function docsNav_path(link) {
    return docsNav_norm(link).split('#')[0]
}
// Документ руководства пользователя (docs/user-guide/…): у таких читалка показывает «Contents»
export function docsNav_inGuide(link) {
    return docsNav_path(link).replace(/^docs\//, '').startsWith(GUIDE_DIR)
}

export function docsNav_state(WIDGET) {
    if (!WIDGET._docsNav) WIDGET._docsNav = { back: [] }
    return WIDGET._docsNav
}

function supportKey(store) {
    return `${store?.user?.database?.dbid || ''}|${store?.version_backend || ''}`
}
// true — open_doc на этом бэке отвечал записью; false — отвечал пустым ответом (метода нет); undefined — ещё не спрашивали
export function docsNav_supported(store) {
    return support[supportKey(store)]
}
// IE 2026 09 28 / ODOO-342342: бэк читалки объявил метод cap ('open_doc' | 'docs_index') в WIDGET.docs_capabilities (ответ widget_open читалки) —
// или выключатель этого метода (CAP_FLAGS) = false: объявление не требуется, как до правки
export function docsNav_backendHas(store, WIDGET, cap) {
    if (docsNav_backendDeclared(WIDGET, cap)) return true   // IE 2026 09 28 / ODOO-342342 (ревью п.6): объявление — docsNav_backendDeclared
    const flag = CAP_FLAGS[cap]
    try { return !!(flag && store && typeof store.setting === 'function' && store.setting(flag, true) === false) } catch (e) { return false }
}

// IE 2026 09 28 / ODOO-342342 (ревью п.6): метод cap объявил САМ бэк (WIDGET.docs_capabilities), а не выключатель. «Метода нет» у такого бэка
// не бывает: ответ без результата (сессия истекла — {isAuthenticated: false}, сбой) — ошибка, «не умеет» не запоминается
export function docsNav_backendDeclared(WIDGET, cap) {
    const caps = WIDGET && WIDGET.docs_capabilities
    return Array.isArray(caps) && caps.includes(cap)
}
// IE 2026 09 28 / ODOO-342342 (ревью п.5): признак методов читалки — только из ЭТОГО ответа бэка (widget_open / updateWIDGET): ключа в ответе
// нет (бэк откатили, пока вкладка открыта) — снять и у виджета, иначе Object.assign / updateWIDGET оставили бы прежний, и фронт звал бы метод,
// которого у бэка нет. Виджеты без признака (все, кроме читалки) не затрагиваются
export function docsNav_dropStaleCaps(WIDGET, answerWIDGET) {
    if (!WIDGET || !('docs_capabilities' in WIDGET) || !answerWIDGET || typeof answerWIDGET !== 'object') return false
    if ('docs_capabilities' in answerWIDGET) return false
    delete WIDGET.docs_capabilities
    return true
}

// Куда ведёт «Contents»: ссылка бэка doc.docs_contents (widgets.docs_contents_link — оглавление руководства у его страниц, кроме самого
// оглавления; '' — не страница руководства или оглавления нет). Записи без поля (бэк до open_doc) — то же правило по пути документа
export function docsNav_contentsLink(WIDGET) {
    const doc = WIDGET?.record?.doc || {}
    if ('docs_contents' in doc) return docsNav_norm(doc.docs_contents)
    const cur = doc.doc_link
    const same = docsNav_path(cur).replace(/^docs\//, '') === docsNav_path(CONTENTS_LINK).replace(/^docs\//, '')
    return docsNav_inGuide(cur) && !same ? CONTENTS_LINK : ''
}

// Какие кнопки показать читалке: back — есть история; contents — есть ссылка на оглавление
export function docsNav_buttons(store, WIDGET) {
    const none = { back: false, contents: false }
    if (!docsNav_on(store) || !docsNav_isDocs(WIDGET)) return none
    if (docsNav_supported(store) === false || !docsNav_backendHas(store, WIDGET, 'open_doc')) {   // IE 2026 09 28 / ODOO-342342: + бэк не объявил open_doc
        // IE 2026 09 28 / ODOO-342342: бэк без open_doc — Back только к месту того же документа (переход к разделу из меню читалки, без запроса)
        const hist = WIDGET._docsNav?.back || [], last = hist[hist.length - 1]
        return { back: !!last && !!docsNav_path(last.link) && docsNav_path(last.link) === docsNav_path(WIDGET.record?.doc?.doc_link), contents: false }
    }
    return {
        back: (WIDGET._docsNav?.back?.length || 0) > 0,
        contents: !!docsNav_contentsLink(WIDGET),
    }
}

export function docsNav_count(key, ms) {
    if (!(key in stats)) return
    stats[key]++
    if (ms != null && (key + 'Ms') in stats) stats[key + 'Ms'] = round(stats[key + 'Ms'] + ms)
}

// Запись для запроса: текст документа (doc.md_text, с картинками data-URI — до мегабайт) бэку не нужен — open_doc читает файл заново
function recordToSend(record) {
    if (!record || typeof record !== 'object') return record
    const out = { ...record }
    if (record.doc && typeof record.doc === 'object') {
        out.doc = { ...record.doc }
        delete out.doc.md_text
    }
    return out
}

// Область прокрутки читалки: первый предок превью AttrMD с overflow auto / scroll в пределах окна виджета
function scroller(WIDGET) {
    try {
        if (typeof document === 'undefined' || !WIDGET) return null
        const root = document.getElementById('WIDGET' + WIDGET.id)
        const prev = root && root.querySelector('.attrmd-preview')
        for (let el = prev && prev.parentElement; el; el = el.parentElement) {
            if (/auto|scroll/.test(getComputedStyle(el).overflowY)) return el
            if (el === root) break
        }
    } catch (e) { /* DOM недоступен — без прокрутки */ }
    return null
}
export function docsNav_scrollTop(WIDGET) {
    const sc = scroller(WIDGET)
    return sc ? sc.scrollTop : null
}
// Новый документ без якоря — к началу (Back — к сохранённой позиции). Якорь ведёт AttrMD.scrollToAnchor; превью перерисовывается
// не сразу — ставим позицию несколько раз
function scrollAfter(WIDGET, top) {
    if (typeof setTimeout === 'undefined') return
    const set = () => { const sc = scroller(WIDGET); if (sc && Math.abs(sc.scrollTop - top) > 2) sc.scrollTop = top }
    for (const ms of [0, 120, 400]) setTimeout(set, ms)
}

// Кнопки Back / Contents зависят от истории, которая обновляется ПОСЛЕ применения ответа (store.executeStoreMethod → content_Changed
// → set_commandPanel) — пересобираем панели AttrMD читалки ещё раз
function refreshPanels(WIDGET) {
    for (const v of Object.values(WIDGET?.attrs_vueObj || {})) {
        if (v && typeof v.onDocsBack === 'function' && typeof v.set_commandPanel === 'function') {
            try { v.set_commandPanel() } catch (e) { /* панель обновится следующим content_Changed */ }
        }
    }
}

// Листать читалку на месте. true — запрос ушёл: ответ применит store (updateDoc / updateWIDGET) или этот модуль, при неудаче вызовется
// opts.fallback (прежний путь). false — листать нельзя (флаг выключен / не читалка / виджета нет / этот бэк не умеет) — вызывающий
// сразу идёт прежним путём.
// opts: fallback() — прежний путь; anchor — кандидаты якоря («?» с вкладкой источника); back — это шаг назад (история уменьшается);
//       restoreScrollTop — позиция для Back; scrollTop — позиция текущего документа (для истории); kind — счётчик stats.
export function docsNav_open(store, WIDGET, link, opts = {}) {
    const target = docsNav_norm(link)
    if (!target || !store || !docsNav_on(store) || !docsNav_isDocs(WIDGET)) return false
    const vueObj = WIDGET.vueObj
    if (!vueObj || WIDGET.close || WIDGET._softClosed) return false
    const key = supportKey(store)
    const declared = docsNav_backendDeclared(WIDGET, 'open_doc')   // IE 2026 09 28 / ODOO-342342 (ревью п.6): бэк объявил — «не умеет» не бывает
    if (support[key] === false && !declared) { stats.skipped++; return false }
    // IE 2026 09 28 / ODOO-342342: бэк не объявил open_doc (WIDGET.docs_capabilities) — не спрашиваем: вызывающий идёт прежним путём (панель)
    if (!docsNav_backendHas(store, WIDGET, 'open_doc')) { stats.noCapability++; return false }
    const from = {
        link: WIDGET.record?.doc?.doc_link || '',
        title: WIDGET.title || '',
        scrollTop: opts.scrollTop !== undefined ? opts.scrollTop : docsNav_scrollTop(WIDGET),
    }
    const t0 = now()
    const params = { doc_link: target }   // путь без схемы docs: — _docs_locate бэка её не снимает («docs:…» = «файл не найден»)
    const anchor = opts.anchor
    if (Array.isArray(anchor) ? anchor.length : anchor) params.anchor = anchor
    let verdict = null
    store.executeStoreMethod(vueObj, {
        command: 'executeWidgetMethod',
        method: 'open_doc',
        params,
        record: recordToSend(WIDGET.record),
        // ДО применения ответа (mainStore.executeWidgetMethod: TERMINAL → _response_callback → … → executeStoreMethod(answer) → _onResponse):
        // неудачный ответ не применяется — снимаем команду и хвост действий, читалка остаётся на прежнем документе
        _response_callback: (answer) => {
            verdict = docsNav_verdict(answer)
            if (verdict !== 'ok' && answer && typeof answer === 'object') { delete answer.command; delete answer.actions_after }
        },
        _onResponse: (answer) => onAnswer(store, WIDGET, key, from, t0, answer, opts, verdict, declared),   // IE 2026 09 28 / ODOO-342342 (ревью п.6): + declared
    })
    return true
}

function onAnswer(store, WIDGET, key, from, t0, answer, opts, verdict, declared) {   // IE 2026 09 28 / ODOO-342342 (ревью п.6): + declared — бэк объявил open_doc
    const ms = now() - t0
    const v = answer ? (verdict || docsNav_verdict(answer)) : 'error'   // HTTP-ошибка: _onResponse(null), _response_callback не звался
    const rec = answer && (answer.record || answer.WIDGET?.record)
    if (v === 'ok') {
        support[key] = true
        if (!APPLIED_BY_STORE.has(answer.command)) {
            // ответ без команды обновления — применяем как updateDoc: запись, заголовок, перерисовка атрибутов виджета
            WIDGET.record = rec
            const title = answer.title !== undefined ? answer.title : answer.WIDGET?.title
            if (title !== undefined && title !== null) WIDGET.title = title
            try { WIDGET.vueObj?.content_Changed?.() } catch (e) { console.warn('docsNav: content_Changed', e) }
        }
        const st = docsNav_state(WIDGET)
        if (opts.back) {
            st.back.pop()
        } else if (from.link && !docsNav_same(from.link, WIDGET.record?.doc?.doc_link)) {
            // тот же документ («Open again» машинного перевода) историю не удлиняет
            st.back.push(from)
            if (st.back.length > HISTORY_MAX) st.back.splice(0, st.back.length - HISTORY_MAX)
        }
        stats.inPlace++
        stats.inPlaceMs = round(stats.inPlaceMs + ms)
        if (opts.kind && opts.kind in stats) stats[opts.kind]++
        const a = WIDGET.record?.doc?.anchor
        if (!(Array.isArray(a) ? a.length : a)) scrollAfter(WIDGET, opts.back && opts.restoreScrollTop != null ? opts.restoreScrollTop : 0)
        refreshPanels(WIDGET)
        return
    }
    if (v === 'unsupported' && !declared) support[key] = false   // пустой ответ без ошибки: на этом бэке open_doc нет (IE 2026 09 28 / ODOO-342342: + только если бэк не объявил метод — ревью п.6)
    else stats.errors++                             // ошибка / без текста / «not found» — прежний путь, механизм не выключаем
    stats.fallback++
    stats.fallbackMs = round(stats.fallbackMs + ms)
    refreshPanels(WIDGET)
    try { opts.fallback?.() } catch (e) { console.warn('docsNav: fallback', e) }
}

// IE 2026 09 28 / ODOO-342342: переход к разделу ТОГО ЖЕ документа (меню читалки: Contents, найденное на открытой странице) — без запроса
// бэка: прежнее место (ссылка, позиция прокрутки) уходит в историю, в записи — якорь раздела (doc.anchor, doc_link с #якорем); прокрутку
// к разделу ведёт вызывающий (AttrMD.scrollToAnchor), без якоря — к началу. false — нельзя (флаг inPlaceDocs выключен / не читалка / нет документа)
export function docsNav_jump(store, WIDGET, anchor, opts = {}) {
    if (!store || !docsNav_on(store) || !docsNav_isDocs(WIDGET)) return false
    const doc = WIDGET.record?.doc
    const path = doc ? docsNav_path(doc.doc_link) : ''
    if (!path) return false
    const st = docsNav_state(WIDGET)
    st.back.push({ link: docsNav_norm(doc.doc_link), title: WIDGET.title || '', scrollTop: opts.scrollTop !== undefined ? opts.scrollTop : docsNav_scrollTop(WIDGET) })
    if (st.back.length > HISTORY_MAX) st.back.splice(0, st.back.length - HISTORY_MAX)
    const a = String(anchor || '')
    doc.doc_link = a ? `${path}#${a}` : path
    doc.anchor = a
    stats.jump++
    if (!a) scrollAfter(WIDGET, 0)
    refreshPanels(WIDGET)
    return true
}

// Кнопка Back: к последнему документу истории. Прежний путь (fallback(link)) — если листать нельзя
// IE 2026 09 28 / ODOO-342342: запись истории того же документа (переход к разделу меню читалки, docsNav_jump) — назад без запроса бэка:
// ссылка, позиция прокрутки; opts.local() — вызывающему (AttrMD: снять доводку прокрутки к прежнему якорю)
export function docsNav_back(store, WIDGET, opts = {}) {
    const st = WIDGET?._docsNav
    const entry = st?.back?.[st.back.length - 1]
    if (!entry) return false
    const link = docsNav_norm(entry.link)
    const doc = WIDGET.record?.doc
    if (doc && docsNav_on(store) && docsNav_path(link) && docsNav_path(link) === docsNav_path(doc.doc_link)) {   // IE 2026 09 28 / ODOO-342342
        st.back.pop()
        doc.doc_link = link
        doc.anchor = ''
        stats.back++
        stats.jumpBack++
        try { opts.local?.() } catch (e) { console.warn('docsNav: local back', e) }
        scrollAfter(WIDGET, entry.scrollTop != null ? entry.scrollTop : 0)
        refreshPanels(WIDGET)
        return true
    }
    const sent = docsNav_open(store, WIDGET, link, {
        back: true, kind: 'back', restoreScrollTop: entry.scrollTop,
        fallback: () => opts.fallback?.(link),
    })
    if (!sent) opts.fallback?.(link)
    return sent
}

// Кнопка Contents: оглавление руководства (ссылка бэка doc.docs_contents, без неё — CONTENTS_LINK)
export function docsNav_contents(store, WIDGET, opts = {}) {
    const link = docsNav_contentsLink(WIDGET) || CONTENTS_LINK
    const sent = docsNav_open(store, WIDGET, link, { kind: 'contents', fallback: () => opts.fallback?.(link) })
    if (!sent) opts.fallback?.(link)
    return sent
}

function hardClose(store, W) {
    if (W._softClosed) {
        // скрытый (Esc) виджет — тем же путём, что таймер closedWidgets
        const list = store.closedWidgets || []
        const i = list.findIndex(x => x.WIDGET === W)
        if (i >= 0) { if (list[i].timerId) clearTimeout(list[i].timerId); list.splice(i, 1) }
        store._widget_hardClose(W)
    } else {
        store.widget_close(W.id, false, true)
    }
}

// store.widget_open нашёл уже открытую читалку (findWidget_byProps), а её просят открыть на ДРУГОМ документе
// (parentAction.params.doc_link — «?» другого виджета, ссылка из AttrMD не-читалки):
//   'nav'    — листаем её на месте (widget_open больше ничего не делает; не вышло — reopen() после жёсткого закрытия);
//   'reopen' — скрыта (Esc) или бэк без open_doc: закрыта жёстко, widget_open открывает новую на нужном документе;
//   null     — не наш случай (флаг выключен, не читалка, нет ссылки, тот же документ): widget_open работает как раньше.
export function docsNav_panelSwap(store, exsist, WIDGET, reopen) {
    if (!docsNav_on(store) || !exsist || !docsNav_isDocs(exsist)) return null
    const params = WIDGET?.parentAction?.params || {}
    const link = params.doc_link
    if (!docsNav_norm(link) || docsNav_same(link, exsist.record?.doc?.doc_link)) return null
    if (exsist.vueObj && !exsist._softClosed && !exsist.close && docsNav_supported(store) !== false && docsNav_backendHas(store, exsist, 'open_doc')) {   // IE 2026 09 28 / ODOO-342342: + признак open_doc
        store.widget_activate(exsist, 'widget_open::docsNav', true, true)
        const sent = docsNav_open(store, exsist, link, {
            anchor: params.anchor, kind: 'panelReused',
            fallback: () => { stats.panelReopened++; hardClose(store, exsist); reopen?.() },
        })
        if (sent) return 'nav'
    }
    stats.panelReopened++
    hardClose(store, exsist)
    return 'reopen'
}

// Консоль: window.helpDocs
export function helpDocs_console(store) {
    if (typeof window === 'undefined') return
    const flags = () => Object.fromEntries(Object.entries(FLAGS).map(([k, key]) => [k, store.setting(key, true) !== false]))
    window.helpDocs = {
        flags: FLAGS,
        get: () => ({ ...flags(), backend: { ...support }, current: supportKey(store), stats: { ...stats } }),
        set(name, value) {
            const key = FLAGS[name] || name
            if (!Object.values(FLAGS).includes(key)) return { error: `helpDocs: no option '${name}'`, options: Object.keys(FLAGS) }
            window.feSettings?.set?.(key, value)
            return this.get()
        },
        // снять override флага и забыть, что отвечали бэки (спросить open_doc заново)
        reset() {
            for (const key of Object.values(FLAGS)) window.feSettings?.unset?.(key)
            for (const k of Object.keys(support)) delete support[k]
            return this.get()
        },
        stats: () => ({ ...stats }),
        clear() { for (const k of Object.keys(stats)) stats[k] = 0; return { ...stats } },
        help: () => 'helpDocs.set("openDocCapability", false) / helpDocs.set("docsIndexCapability", false) — звать open_doc / docs_index и без признака бэка (IE 2026 09 28 / ODOO-342342); helpDocs.set("inPlaceDocs", false) — прежнее поведение ссылок документации (панель, без Back / Contents); helpDocs.set("docsSearch", false) — прежнее меню читалки (≡ слева, без поиска по инструкциям); helpDocs.set("readerTitleH1", false) — заголовок читалки при открытии как раньше (подпись строки страницы, а не H1); .reset() — снять override и забыть ответы бэков; .stats() / .clear() — счётчики; .search() — замеры меню и поиска читалки',   // IE 2026 09 28 / ODOO-342342: + docsSearch, + readerTitleH1
    }
}

// для тестов: сброс состояния модуля
export function docsNav__resetForTests() {
    for (const k of Object.keys(support)) delete support[k]
    for (const k of Object.keys(stats)) stats[k] = 0
}
